import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "cdnsa-cdn-comparison",
  module: widgetModule,
  catalog: {
    description: "Nonexclusive CDN associations by detection type.",
    domain: "cdnsa",
    visual: "Bar chart",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", rowAlignment: "stretch" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
